// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"444e08d0","455":"e313e2ff","977":"3485a206"}[chunkId] + ".chunk.js";
};